module.exports = __webpack_public_path__ + "static/img/r-3-1-icon.44220a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-3/r-3-1-icon.png
// module id = dcEJ
// module chunks = 0